export const getMediaUploadPermissionUrl = (projectId: string) =>
	`/rest/api/3/attachment/upload/issue/credentials/adf?projectIdOrKey=${projectId}`;
export const getAttachmentsFieldCollectionUrl = (projectId: string) =>
	`/rest/api/latest/attachment/upload/project/${projectId}/credentials`;
